const urlAdmin = process.env.REACT_APP_SERVER_URL_ADMIN

const legalDocument = {
    id: '1',
    adminId: '1',
    type: 'ADMIN_DOCUMENT_TYPE_PERSONAL_DATA_PROCESSING_POLICY',
    code: 'privacy-policy',
    title: 'Политика обработки персональных данных',
    description: '',
    status: 'ADMIN_DOCUMENT_STATUS_ACTIVE',
    currentPublishedVersionId: '15',
    createdBy: '1',
    updatedBy: '1',
    createdAt: '2026-09-27T10:00:00Z',
    updatedAt: '2026-09-27T10:00:00Z',
}

const legalDocumentVersions = [
    {
        id: '15',
        documentId: '1',
        adminId: '1',
        number: '1.0',
        fileName: 'privacy-policy.pdf',
        mimeType: 'application/pdf',
        sizeBytes: '245760',
        checksum: '',
        status: 'ADMIN_DOCUMENT_VERSION_STATUS_PUBLISHED',
        publishedAt: '2026-09-27T10:00:00Z',
        changeNote: 'Первая редакция',
        createdBy: '1',
        updatedBy: '1',
        createdAt: '2026-09-27T09:00:00Z',
        updatedAt: '2026-09-27T10:00:00Z',
    },
    {
        id: '16',
        documentId: '1',
        adminId: '1',
        number: '1.1',
        fileName: 'privacy-policy-draft.docx',
        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        sizeBytes: '185320',
        checksum: '',
        status: 'ADMIN_DOCUMENT_VERSION_STATUS_DRAFT',
        publishedAt: '',
        changeNote: 'Уточнение порядка хранения данных',
        createdBy: '1',
        updatedBy: '1',
        createdAt: '2026-09-27T11:00:00Z',
        updatedAt: '2026-09-27T11:00:00Z',
    },
]

export const LegalInfoMocks: {[key: string]: any} = {
    [`${urlAdmin}/api/v1/legal-info`]: {
        legalInfo: {
            id: '1',
            adminId: '1',
            fullName: 'Индивидуальный предприниматель Кононов Иван Сергеевич',
            inn: '490909865955',
            ogrnip: '325490000006332',
            registrationAddress: '685007, Магаданская область, г. Магадан, улица Берзина, д. 4, кв./оф. 33',
            email: 'ivkon1223@gmail.com',
            createdAt: '2026-09-26T10:00:00Z',
            updatedAt: '2026-09-26T10:00:00Z',
            updatedBy: '1',
        },
    },
    [`${urlAdmin}/api/v1/legal-info/domain`]: {
        domain: {
            id: '1',
            adminId: '1',
            hostname: 'school.example.ru',
            status: 'ADMIN_DOMAIN_STATUS_ACTIVE',
            ownershipVerifiedAt: '2026-09-24T09:30:00Z',
            domainPaidUntil: '2027-09-24',
            certificateIssuedAt: '2026-09-24T10:00:00Z',
            certificateExpiresAt: '2026-12-23T10:00:00Z',
            certificateProvider: "Let's Encrypt",
            nginxConfigAppliedAt: '2026-09-24T10:05:00Z',
            lastError: '',
            createdAt: '2026-09-24T09:00:00Z',
            updatedAt: '2026-09-24T10:05:00Z',
        },
    },
    [`${urlAdmin}/api/v1/legal-info/domain/sync`]: {
        domain: {
            id: '1',
            adminId: '1',
            hostname: 'school.example.ru',
            status: 'ADMIN_DOMAIN_STATUS_PROVISIONING',
            ownershipVerifiedAt: '2026-09-24T09:30:00Z',
            domainPaidUntil: '2027-09-24',
            certificateIssuedAt: '2026-09-24T10:00:00Z',
            certificateExpiresAt: '2026-12-23T10:00:00Z',
            certificateProvider: "Let's Encrypt",
            nginxConfigAppliedAt: '2026-09-24T10:05:00Z',
            lastError: '',
            createdAt: '2026-09-24T09:00:00Z',
            updatedAt: '2026-09-27T10:50:00Z',
        },
    },
    [`${urlAdmin}/api/v1/legal-documents`]: (init?: RequestInit) => init?.method === 'POST'
        ? {document: legalDocument}
        : {documents: [legalDocument]},
    [`${urlAdmin}/api/v1/legal-documents/:documentId`]: {document: legalDocument},
    [`${urlAdmin}/api/v1/legal-documents/:documentId/versions`]: (init?: RequestInit) => init?.method === 'POST'
        ? {version: legalDocumentVersions[1]}
        : {versions: legalDocumentVersions},
    [`${urlAdmin}/api/v1/legal-documents/versions/:versionId/make-primary`]: {version: legalDocumentVersions[1]},
    [`${urlAdmin}/api/v1/legal-documents/versions/:versionId`]: {version: legalDocumentVersions[0]},
    [`${urlAdmin}/api/v1/legal-documents/versions/:versionId/download`]: {
        version: legalDocumentVersions[0],
        contentType: 'application/pdf',
        content: 'SGVsbG8=',
    },
}
